module.exports = function getResource(label, vars = []) {
    let resources = {
        minimum: 'Min.',
        characters: 'characters'
    };

    return resources[label];
};
